import { useMemo, useState } from 'react'
import { DashboardLayout } from '../../components/layout'
import { Button, Modal } from '../../components/ui'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { useMeetings } from '../../hooks'
import { useToast } from '../../context/ToastContext'
import MeetingForm from '../../features/operations/MeetingForm'
import MeetingList from '../../features/operations/MeetingList'

function MeetingsPage() {
  const { meetings, loading, createMeeting } = useMeetings()
  const [showAddModal, setShowAddModal] = useState(false)
  const [formLoading, setFormLoading] = useState(false)
  const [search, setSearch] = useState('')
  const toast = useToast()

  const filteredMeetings = useMemo(() => {
    if (!search) return meetings
    const query = search.toLowerCase()
    return meetings.filter(meeting => {
      const decisions = (meeting.decisions || []).map(decision => `${decision.title} ${decision.decision}`).join(' ')
      const actions = (meeting.action_items || []).map(item => item.description).join(' ')
      return [meeting.title, meeting.summary, meeting.attendees, decisions, actions]
        .filter(Boolean)
        .some(text => text.toLowerCase().includes(query))
    })
  }, [meetings, search])

  const handleCreateMeeting = async (meeting, decisions, actionItems) => {
    setFormLoading(true)
    const { error } = await createMeeting(meeting, decisions, actionItems)
    setFormLoading(false)

    if (error) {
      toast.error('Failed to save meeting')
      return
    }

    toast.success('Meeting logged')
    setShowAddModal(false)
  }

  if (loading) {
    return (
      <DashboardLayout title="Meetings">
        <LoadingSpinner.Overlay message="Loading meetings..." />
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout
      title="Meetings"
      actions={<Button onClick={() => setShowAddModal(true)}>+ Log Meeting</Button>}
    >
      <div className="card mb-6">
        <div className="form-group">
          <label className="form-label">Search Meetings & Decisions</label>
          <input
            className="form-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by title, summary, decisions, actions"
          />
        </div>
      </div>

      <MeetingList meetings={filteredMeetings} />

      <Modal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Log Meeting"
      >
        <MeetingForm
          onSubmit={handleCreateMeeting}
          onCancel={() => setShowAddModal(false)}
          loading={formLoading}
        />
      </Modal>
    </DashboardLayout>
  )
}

export default MeetingsPage
